/** Remotion timeline 프레임 기준을 절대 ms로 맞추기 위한 보조 함수. */
export const convertFrameToMs = (frame: number, fps: number) => {
  if (!Number.isFinite(frame) || fps <= 0) {
    return 0;
  }

  return Math.round((frame / fps) * 1000);
};
